import { HostEvent, LiveboardEmbed as LiveboardEmbedRef } from '@thoughtspot/visual-embed-sdk';
import { LiveboardEmbed, useEmbedRef } from '@thoughtspot/visual-embed-sdk/lib/src/react';
import cx from 'classnames/bind';
import { isThoughtspotEnabled } from 'utils/thoughtspotInit';
import { LiveboardProps } from './LiveboardVisuals.types';

const LiveboardVisuals: React.FC<LiveboardProps> = ({
  liveboardId,
  customizations,
  visibleActions = [],
  visualId,
  filterByOptions,
  runtimeParameters,
  updateLiveboardParameters = [],
  onLiveboardError = () => {},
  onDataLoaded = () => {},
  frameStyles,
}) => {
  const embedRef = useEmbedRef() as React.MutableRefObject<LiveboardEmbedRef>;

  if (!isThoughtspotEnabled) {
    return (
      <div className="flex flex-grow items-center justify-center text-neutral-500 body-base">
        Analytics not available in this environment.
      </div>
    );
  }

  return (
    <LiveboardEmbed
      frameParams={{ width: '100%', height: '100%' }}
      customizations={customizations}
      className={cx('liveboard-content flex flex-grow', frameStyles)}
      ref={embedRef}
      liveboardId={liveboardId}
      runtimeFilters={filterByOptions}
      runtimeParameters={runtimeParameters}
      onError={onLiveboardError}
      additionalFlags={{
        hasSeenPinsFlow: false,
        isReorderedEllipsisMenuEnabled: false,
        isSendNowLiveboardSchedulingEnabled: true,
      }}
      isLiveboardHeaderSticky={false}
      vizId={visualId}
      visibleActions={visibleActions}
      onData={onDataLoaded}
      onLiveboardRendered={() => {
        if (updateLiveboardParameters.length > 0) {
          embedRef.current.trigger(HostEvent.UpdateParameters, updateLiveboardParameters);
        }
      }}
      hideIrrelevantChipsInLiveboardTabs
      isLiveboardCompactHeaderEnabled
      isLiveboardMasterpiecesEnabled
      isLiveboardXLSXCSVDownloadEnabled
      isGranularXLSXCSVSchedulesEnabled
    />
  );
};

export default LiveboardVisuals;
